// extracted by mini-css-extract-plugin
export var searchHeader = "_2i-0";
export var searchHeaderDark = "_2i-1";